import { ResponsiveImage } from '~/graphql/fragments'
import { graphql } from '~/lib/datocms/graphql'

export const queryWorks = graphql(
  /* GraphQL */ `
    query Works(
      $first: IntType = 100
      $skip: IntType
      $allInCategory: [ItemId]
      $notInSlug: [String]
    ) {
      _allWorksMeta(filter: { category: { allIn: $allInCategory }, slug: { notIn: $notInSlug } }) {
        count
      }
      allWorks(
        first: $first
        skip: $skip
        filter: { category: { allIn: $allInCategory }, slug: { notIn: $notInSlug } }
      ) {
        __typename
        _modelApiKey
        id
        clients {
          id
          name
          slug
        }
        category {
          __typename
          _modelApiKey
          id
          name
          slug
        }
        image {
          alt
          url
          width
          height
          responsiveImage(
            imgixParams: { auto: compress, crop: focalpoint, fit: crop, ar: "4:3", w: 440 }
          ) {
            ...ResponsiveImage
          }
        }
        title
        slug
      }
    }
  `,
  [ResponsiveImage]
)
